import call, { json } from './call';

// The Links puzzle endpoints (CONTEXT.md "Links puzzle").
export const listLinksPuzzles = (token) => call('/api/links/review', token, { method: 'GET' });
export const updateLinksPuzzle = (token, id, groups) => call(`/api/links/puzzles/${id}`, token, json('PUT', { groups }));
export const deleteLinksPuzzle = (token, id) => call(`/api/links/puzzles/${id}`, token, { method: 'DELETE' });
export const approveLinksPuzzle = (token, id, date) => call(`/api/links/puzzles/${id}/approve`, token, json('POST', { date }));
export const unscheduleLinksPuzzle = (token, id) => call(`/api/links/puzzles/${id}/approve`, token, { method: 'DELETE' });
// Admin override: the puzzle's number (later ones count on from it); null goes back to counting.
export const setLinksPuzzleNumber = (token, id, number) => call(`/api/links/puzzles/${id}/number`, token, json('PUT', { number }));
export const listLinksCourses = (token) => call('/api/links/courses', token, { method: 'GET' }).then(data => data.items || []);
// Queues a draft for `date` at `level`; courseIds are pinned (up to 4).
export const generateLinksPuzzle = (token, { date, level, courseIds = [] }) => call(
    '/api/links/generations', token, json('POST', { date, level, course_ids: courseIds }),
);
